import React from "react";
import { Box, Typography, Stack, Switch, styled } from "@mui/material";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 39,
  height: 20,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 16,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(19px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(19px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#1890ff",
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 16,
    height: 16,
    borderRadius: 16 / 2,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: "#E9E9EA",
    boxSizing: "border-box",
  },
}));

const MusicPlayer = ({ switchLabels, switchState, handleToggle }) => {
  return (
    <Box
      sx={{
        mt: 8,
        mb: 8,
        p: 3,
        boxShadow: "1.5px 2.6px 10px 0px #7777771A",
        width: "100%",
      }}
    >
      <Typography fontSize="20px" fontWeight="600" gutterBottom>
        Music Player
      </Typography>

      <Stack spacing={1}>
        {switchLabels.map((label) => (
          <Box
            key={label}
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            mt={3}
          >
            <Typography
              fontSize="16px"
              fontWeight="600"
              color="#6A707E"
              sx={{ width: "150px" }}
            >
              {label}
            </Typography>
            <AntSwitch
              checked={switchState[label]}
              onChange={() => handleToggle(label)}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default MusicPlayer;
